import addShowClicked from "../events/add-show-clicked.js";
import showDeleted from "../events/show-deleted.js";
import showCreated from "../events/show-created.js";
import showUpdated from "../events/show-updated.js";
function makeEventRouter() {
    const router = {
        'add-show-clicked': addShowClicked
    };
    const routerWithData = {};
    //@ts-ignore
    const formRouterWithData = {
        'form-created': showCreated,
        'form-updated': showUpdated,
        'form-deleted': showDeleted
    };
    return Object.freeze({
        get,
        getWithData,
        getFormActionWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
    function getFormActionWithData(action) {
        return formRouterWithData[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
